import React from "react";
import BannerImg from "../../../assets/liveCourses/courseBanner.png";

const Banner = () => {
  return (
    <div className="  bg-no-repeat border-2 w-full relative">
      <img className="w-full h-[90vh] object-cover -ml-1" src={BannerImg} alt="BannerImg" />
      <div className="max-w-3xl absolute top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 max-sm:w-full max-sm:px-5 ">
        <h1 className="text-4xl max-w-xl m-auto text-white font-semibold text-center max-sm:text-2xl">
          Join the Journey to Mastery: Courses for Your Goal
        </h1>
        <p className="mt-5 text-lg font-normal text-center text-[#F7F9FB] max-sm:text-base ">
          Whether you're just starting or looking to enhance your skills, our
          courses are designed to guide you every step of the way to success.
        </p>
      </div>
    </div>
  );
};

export default Banner;
